var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"acdwxlcsg"},_vm._l((_vm.items),function(item,index){return _c('a',{key:index,class:{active:_vm.days==item},on:{"click":function($event){return _vm.clickspan(item)}}},[_vm._v(_vm._s(item)+"日")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-215898b4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/kanban/abc/statrEnd.vue
// module id = null
// module chunks = 